/** 상점 업무처리 */
export default class StoreWorkProcess {
    _id = '';
    get id() {
        return this._id;
    }
    set id(value) {
        this._id = value;
    }
    _title = '';
    get title() {
        return this._title;
    }
    set title(value) {
        this._title = value;
    }
    _body = '';
    get body() {
        return this._body;
    }
    set body(value) {
        this._body = value;
    }
    _createdAt = 0;
    get createdAt() {
        return this._createdAt;
    }
    set createdAt(value) {
        this._createdAt = value;
    }
    /** 허브명 */
    _hubName = '';
    get hubName() {
        return this._hubName;
    }
    set hubName(value) {
        this._hubName = value;
    }
    /** 작성자 아이디 */
    _createdBy = '';
    get createdBy() {
        return this._createdBy;
    }
    set createdBy(value) {
        this._createdBy = value;
    }
    /** 작성자 이름 */
    _createdByName = '';
    get createdByName() {
        return this._createdByName;
    }
    set createdByName(value) {
        this._createdByName = value;
    }
    /** 중요 글 여부 */
    _isImportant = false;
    get isImportant() {
        return this._isImportant;
    }
    set isImportant(value) {
        this._isImportant = value;
    }
    /**
     * 답변글 여부
     */
    _isReply = false;
    get isReply() {
        return this._isReply;
    }
    set isReply(value) {
        this._isReply = value;
    }
    /**
     * 삭제 글 여부
     */
    _isDeleted = false;
    get isDeleted() {
        return this._isDeleted;
    }
    set isDeleted(value) {
        this._isDeleted = value;
    }
    /** 특정 허브 대상일 경우 */
    _hub = {};
    get hub() {
        return this._hub;
    }
    set hub(value) {
        this._hub = value;
    }
    /** 유저 타입 */
    _userType = '';
    get userType() {
        return this._userType;
    }
    set userType(value) {
        this._userType = value;
    }
    /**
     * 글 답변 레벨
     * 0: 원글
     * 1: 답변
     * 2: 답변의 답변
     */
    _displayDepth = 0;
    get displayDepth() {
        return this._displayDepth;
    }
    set displayDepth(value) {
        this._displayDepth = value;
    }
    /** 내 글 여부 */
    _isMine = false;
    get isMine() {
        return this._isMine;
    }
    set isMine(value) {
        this._isMine = value;
    }
    /** 작성자 허브 name */
    _createdByHubName = '';
    get createdByHubName() {
        return this._createdByHubName;
    }
    set createdByHubName(value) {
        this._createdByHubName = value;
    }
    constructor(_data) {
        if (!_data) {
            return;
        }
        const data = this.translate(_data);
        Object.assign(this, data);
    }
    /**
     * 서버 응답값을 프론트 도메인 형태로 변환
     * back-end -> front-end
     */
    // eslint-disable-next-line class-methods-use-this
    translate(data) {
        return {
            ...data,
        };
    }
    /**
     * 본인 글 여부 판단
     */
    setIsMine(id) {
        this.isMine = this.createdBy === id;
    }
}
